import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["href", "onMouseover"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-avatar--followed _flex _jc-c _ai-c _bgc--accent _tc--white"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_user_follow = _resolveComponent("user-follow")
  const _component_base_avatar = _resolveComponent("base-avatar")
  const _component_comment_user_balloon = _resolveComponent("comment-user-balloon")

  return (_openBlock(), _createBlock(_component_comment_user_balloon, { author: $props.author }, {
    trigger: _withCtx(({ showBalloon }) => [
      _createElementVNode("a", {
        href: $props.author.profileUrl,
        class: "gfu-link--nofx _pos-r _flex",
        onMouseover: $event => ($options.onMouseover(showBalloon))
      }, [
        _createVNode(_component_base_avatar, {
          "avatar-url": $props.author.avatarUrl,
          alt: $props.author.nickname,
          class: _normalizeClass({ '_cur-p': $options.hasUrlName }),
          clean: true
        }, {
          default: _withCtx(() => [
            ($options.hasUrlName)
              ? (_openBlock(), _createBlock(_component_user_follow, {
                  key: 0,
                  nickname: $props.author.nickname,
                  "user-url-name": $props.author.urlName,
                  "user-id": $props.author.userID
                }, {
                  default: _withCtx(({ isFollowing }) => [
                    isFollowing
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_base_icon, {
                            "icon-namespace": "ga",
                            name: "heart-solid-icon"
                          })
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["nickname", "user-url-name", "user-id"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["avatar-url", "alt", "class"])
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["author"]))
}